import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button, CheckboxGroup, Span } from "@icg360/design-system";

import { MultiStepFormLayout } from "components/multi-step-form-layout";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";
import {
  WindDefenseContext,
  type WindDefenseContextState,
} from "pages/offer/wind-defense/wind-defense-flow";

import styles from "./shingle-reseal.module.scss";

export const WaiverSageSure = () => {
  const navigate = useNavigate();
  const { formNavigate, setFields, state } =
    useMultiStepFormState<WindDefenseContextState>(WindDefenseContext);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      !(
        state?.phone &&
        state?.firstName &&
        state?.lastName &&
        state?.emailAddress
      )
    ) {
      navigate("../policy-confirmation");
    }
  }, [
    navigate,
    state?.emailAddress,
    state?.firstName,
    state?.lastName,
    state?.phone,
  ]);

  const onAgreeClick = (val) => {
    setFields({ termsSageSureAgreed: val });
    setShowError(false);
  };

  const onSubmit = async () => {
    if (!state.termsSageSureAgreed) {
      setShowError(true);
      return;
    }

    formNavigate("../waiver-liftlock");
  };

  return (
    <MultiStepFormLayout
      noScroll
      step={3}
      totalSteps={5}
      heading="Please read and agree to SageSure’s waiver"
      buttonProps={{
        primary: { onPress: onSubmit },
        cancel: { path: "/my/property-services/wind-defense" },
        promptOnCancel: true,
        formNavigate,
      }}
    >
      <div className={styles.termsContent}>
        <div className={styles.terms}>
          {state?.termsSageSure?.split("\n").map((paragraph, i) => (
            <p key={i}>
              {i === 0 ? (
                <Button
                  icon="Print"
                  appearance="secondary"
                  size="xs"
                  className={styles.printButtonDS}
                  onPress={print}
                  data-testid="waiver-print"
                />
              ) : null}
              {paragraph}
            </p>
          ))}
        </div>
        <Span className={styles.printHideDS}>
          <div className={styles.checkBox}>
            <CheckboxGroup
              isError={showError}
              errorMessage="Please agree to the waiver before submitting."
              aria-label="I have read and agreed to the waiver above."
              defaultValue={state.termsSageSureAgreed ? ["agreed"] : []}
            >
              <CheckboxGroup.Checkbox
                onChange={onAgreeClick}
                isInvalid={showError}
                value="agreed"
              >
                I have read and agreed to the waiver above.*
              </CheckboxGroup.Checkbox>
            </CheckboxGroup>
          </div>
        </Span>
      </div>
    </MultiStepFormLayout>
  );
};
